/**
 * The code has been taken from:
 *
 * {@link https://stackoverflow.com/questions/3452546/how-do-i-get-the-youtube-video-id-from-a-url}
 *
 * @param {string} url
 * @returns {string} YT video id or the url itself.
 *
 */

export function youtube_parser(url = "") {
  var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  var match = url.match(regExp);
  return match && match[7].length === 11 ? match[7] : url;
}
